// TODO: Move to @dealroadshow/uikit dateFormats after BS filters are complete
/**
 * Pattern: 'E, MMM d, yyyy'
 *
 * Example: Wed, Mar 11, 2026
 */
const WEEKDAY_SHORT_MONTH_DAY_YEAR_FORMAT = 'E, MMM d, yyyy';

export { WEEKDAY_SHORT_MONTH_DAY_YEAR_FORMAT };
